export const roundToCents = (price: number) => Math.round(price * 100) / 100;
